import React from "react";
import { useLocation } from "react-router-dom";
import { LogIn, ShieldCheck, ArrowLeft } from "lucide-react";
import { COMPANY } from "@/lib/translations";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AdminLogin = () => {
  const location = useLocation();
  const error = location.state?.error;

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div className="min-h-screen bg-[color:var(--bg-primary)] text-white flex items-center justify-center px-5 py-16">
      <div className="w-full max-w-md">
        <a
          href="/"
          data-testid="admin-back-link"
          className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-zinc-400 hover:text-[color:var(--gold)] transition-colors mb-10"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Voltar ao site
        </a>

        <div className="bento-card p-8 sm:p-10">
          <div className="flex items-center gap-3">
            <img
              src={COMPANY.logo}
              alt="Faustitur"
              className="h-12 w-12 object-cover rounded-sm border border-white/10"
            />
            <div className="leading-tight">
              <p className="font-display text-xl text-white">Faustitur</p>
              <p className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--teal)]">
                Admin · Reservas
              </p>
            </div>
          </div>

          <h1 className="font-display text-3xl mt-8 tracking-tight">
            Entrar no painel
          </h1>
          <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
            Aceda às reservas recebidas com a conta Google autorizada
            (faustitur@gmail.com).
          </p>

          {error && (
            <div
              data-testid="admin-login-error"
              className="mt-6 border border-red-500/30 bg-red-500/10 text-red-300 text-sm px-4 py-3 rounded-sm"
            >
              Não foi possível autenticar. Tente novamente.
            </div>
          )}

          <button
            type="button"
            data-testid="admin-google-login"
            onClick={handleLogin}
            className="btn-gold mt-8 w-full justify-center"
          >
            <LogIn className="h-4 w-4" />
            Continuar com Google
          </button>

          <div className="mt-8 flex items-start gap-3 text-xs text-zinc-500">
            <ShieldCheck className="h-4 w-4 text-[color:var(--gold)] shrink-0 mt-0.5" />
            <p>
              Sessão segura via Emergent OAuth. Apenas emails autorizados podem
              aceder.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
